import React, { useState } from "react";

const FAQSection = ({ items, heading = "Frequently Asked Questions" }) => {
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <section className="bg-white border-t border-gray-200 py-10 sm:py-14" aria-labelledby="faq-section-heading">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <h2 id="faq-section-heading" className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-8">{heading}</h2>
        <div className="space-y-3" role="list" aria-label="Frequently asked questions">
          {items.map((item, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden" role="listitem">
              <button
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left font-medium text-gray-900 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 transition-colors"
                aria-expanded={openIdx === i}
                aria-controls={`faq-a-${i}`}
                id={`faq-q-${i}`}
              >
                <span className="pr-4">{item.q}</span>
                <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 flex-shrink-0 text-gray-500 transition-transform ${openIdx === i ? "rotate-180" : ""}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
              </button>
              {openIdx === i && (
                <div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} className="px-5 pb-4 text-gray-600 leading-relaxed">{item.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
